import GeometryType from 'ol/geom/GeometryType';
import { convertProjection4329 } from '../utils';
import { Feature, GeoJsonProperties, Geometry, Position } from 'geojson';

export function parseGeoJsonText(geoJsonText: string): GeoJSON.FeatureCollection | null {
  try {
    const geoJson = JSON.parse(geoJsonText);

    if (geoJson.type === 'FeatureCollection' && Array.isArray(geoJson.features)) {
      return geoJson as GeoJSON.FeatureCollection;
    }

    return null;
  } catch (error) {
    console.error('Error parsing GeoJSON text:', error);

    return null;
  }
}

export function coordsFromGeoJsonFeature(
  feature: Feature<Geometry, GeoJsonProperties>,
): Position[][][] | Position[][] | null {
  const geometryType = feature.geometry.type;

  if (geometryType !== GeometryType.POLYGON && geometryType !== GeometryType.MULTI_POLYGON) {
    return null;
  }

  const geomCoordinates = feature.geometry.coordinates;

  if (geometryType === GeometryType.MULTI_POLYGON) {
    const coords = geomCoordinates as Position[][][];

    return coords.map((complexPolygon) =>
      complexPolygon.map((ring) => ring.map((coords) => convertProjection4329(coords))),
    );
  }

  const coords = geomCoordinates as Position[][];
  const c = coords.map((ring: Position[]) => ring.map((coords: Position) => convertProjection4329(coords)));

  return c;
}
